export default class ParameterCollection
{
    #store = null;
    #items = [];
    #prototypeCode = null;

    constructor(store, items = [], prototypeCode = null)
    {
        this.#store = store;
        this.setItems(items);
        this.setPrototypeCode(prototypeCode);
    }

    getItems()
    {
        return this.#items;
    }

    getPrototypeCode()
    {
        return this.#prototypeCode;
    }

    setItems(items)
    {
        this.#items = items;
    }

    setPrototypeCode(prototypeCode)
    {
        this.#prototypeCode = prototypeCode;
    }

    getAccessibleItems()
    {
        const collection = [];

        // Order
        for(const key in this.#items)
        {
            if(parseInt(this.#store.getters['parameters/getProperty'](this.#prototypeCode, key, 'has_access')))
            {
                collection.push({
                    parameterCode:  key,
                    parameterValue: this.#items[key],
                    parameterOrder: parseInt(this.#store.getters['parameters/getProperty'](this.#prototypeCode, key, 'sort_order')),
                });
            }
        }

        // Order values
        return collection.sort((a, b) => a.parameterOrder - b.parameterOrder);
    }
}
